<template>
	<div class="stockin" :style="{ height: `${windowHeight}px` }">
		<el-row>
			<el-col :span="2" class="collabel"><span>入库单号</span></el-col>
			<el-col :span="4"><el-input size="mini" ref="billid" v-model="stockin.billid" @keyup.native="val => enterinput(val, 'crm_c_id', '')" :disabled="true"></el-input></el-col>
			<el-col :span="2" class="collabel"><span>供应商</span></el-col>
			<el-col :span="4">
				<el-select
					ref="crm_c_id"
					v-model="stockin.crm_c_cname"
					filterable
					remote
					reserve-keyword
					size="mini"
					placeholder="请输入关键词"
					:remote-method="customerinput"
					@keyup.native="val => enterinput(val, 'storehouse', 'billid')"
					@change="handleSelect"
					:loading="loading"
				>
					<el-option v-for="item in customerlist" :key="item.cname" :label="item.cname" :value="item.cname"></el-option>
				</el-select>
			</el-col>
			<el-col :span="2" class="collabel"><span>所在仓库</span></el-col>
			<el-col :span="4">
				<el-select
					ref="storehouse"
					v-model="stockin.storehouse"
					size="mini"
					@keyup.native="val => enterinput(val, 'remark', 'crm_c_id')"
				>
					<el-option v-for="(opt, opti) in storehouselist" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
				</el-select>
				
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="2" class="collabel"><span>备  注</span></el-col>
			<el-col :span="10">
				<el-input size="mini" ref="remark" v-model="stockin.remark" @keyup.native="val => enterinput(val, 'tablegrid', 'storehouse')"></el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24" style="padding-left:15px">
				<tableui
					style="width:99%;"
					ref="tablegridstockin"
					v-loading="loading"
					:tableData="stockin.cargolist"
					:columns="cargocol"
					:gridheight="gridheight"
					editcell="1"
					:stripe="false"
					@gridhandle="stockinhandle"
					@autoaddrow="stockinhandle"
					@setuparrow="setuparrow"
				></tableui>
			</el-col>
		</el-row>
		<el-row class="footerhandler" v-if="!btndisabled">
			<el-col :span="5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn"><div @click="savestockin" ref="save">保存</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="reback" ref="reback">返回</div></el-col>
		</el-row>
		<el-dialog :visible.sync="showcargolistwin" title="选择商品" width="95%" :close-on-click-modal="false" lock-scroll :append-to-body="true" :show-close="false">
			<cargolist ref="selectcargo" :urlparam="cargoparam"></cargolist>
			<span slot="footer" class="dialog-footer">
				<div style="text-align: center;width:100%">
					<el-button size="mini" type="success" @click.native="surecargo">确定</el-button>
					<el-button size="mini" type="info" plain @click.native="closecargo">关闭</el-button>
				</div>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import cargolist from '@/pages/baseinfo/cargolist';
export default {
	components: {
		tableui,
		cargolist
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			loading:false,
			showcargolistwin:false,
			storehouselist:[],//仓库选项
			customerlist:[],
			windowHeight: window.innerHeight - 150,
			gridheight: window.innerHeight - 200 + 'px',
			stockin:{
				billid:'',
				crm_c_cname:'',
				crm_c_id:'',
				storehouse:'',
				remark:'',
				cargolist:[] //商品明细
			},
			cargocol:[],
			btndisabled:false,
			cargorow:{},
			divclass:'stockin',
			cargoparam:{}, //选择商品
			gridrowindex:-1,
			gridcolindex:-1
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/stockmanager/stock_in.scss');
			this.GetStoreHouse();
			this.GetCargocol();
		});
		var that=this;
		setTimeout(function() {
			that.$refs['crm_c_id'].focus();
		}, 200);
		this.stockin.billid=new Date().getTime();
	},
	methods:{
		GetCargocol(){
			var that=this;
			this.$apipost.get.GetColumns({ tab:'cargolist',checkfield:0,parentid:'',mode:'仓库管理-入库' }).then(res => {
				that.cargocol=res;
				if(res!=undefined){
					res.forEach(e=>{
						that.cargorow[e.field]='';
					});
					that.stockin.cargolist.push(JSON.parse(JSON.stringify(that.cargorow)));
				}
			});
		},
		//获取仓库
		GetStoreHouse(){
			var that=this;
			this.$apipost.get.GetDicByRole({ type:'仓库' }).then(res => {
				that.storehouselist=that.storehouselist.concat(res.list);
			});
		},		
		//选择客户联动
		customerinput(val) {
			var that = this;
			var search = {
				searchbox: val,
				c_type: '供应商,客户及供应商'
			};
			this.$tool.customerlink(this, search, 'page');
		},
		//文本框回车
		enterinput(event, colnext, colperv) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (colnext != '') {
						if (colnext == 'tablegrid') this.$refs.tablegridstockin.setgridfoucs();
						else this.$refs[colnext].focus();
					}
				} else if (event.keyCode == 37) {
					if (colperv != '') this.$refs[colperv].focus();
				}
			}
		},
		//选中提示选项时
		handleSelect(item) {
			var list = this.customerlist.filter(e => {
				return e.cname == item;
			});
			if (list.length > 0) {
				this.stockin.crm_c_id = list[0].id;
			}
		},
		//删除行
		deleteRow(e) {
			this.stockin.cargolist.splice(e.index, 1);
			if (this.stockin.cargolist.length < 1) {
				this.stockin.cargolist.push(JSON.parse(JSON.stringify(this.cargorow)));
			}
		},
		setuparrow() {
			this.enterinput({ keyCode: 37 }, '', 'remark');
		},
		//列表操作事件
		stockinhandle(e) {
			var that=this;
			if (e.event == 'addrow') {
				this.stockin.cargolist.splice(e.index + 1, 0, JSON.parse(JSON.stringify(this.cargorow)));
			}
			if (e.event == 'delrow') {
				this.deleteRow(e);
			}
			if(e.event=='getcargo'){
				this.GetCargo(e,false);//获取商品基本信息
			}
		},
		//获取商品勾选行
		GetCargo(e,iscallback){
			//获取商品信息
			var that=this;
			if(that.stockin.storehouse==''){
				this.$tool.message('请选择所属仓库', 0);
				return false;
			}
			var rowindex=e.index;
			var colindex=e.colindex;
			
			this.gridrowindex=rowindex;
			this.gridcolindex=colindex;
			var search=new Object();
			search.storehouse=that.stockin.storehouse;
			if(iscallback){
				search=JSON.parse(e.search);
			}else{
				var field=e.field;
				search[field]=this.stockin.cargolist[rowindex][field];
			}
			var paraminfo = {
				search: JSON.stringify(search),
				pageindex:0,
				pagesize:200,
				sort:'',
				tab:'tab1',
				l_mode:'商品库管理',
				showcol:'',
				userid: localStorage.getItem('userid'),
				ispublic:'1'
			};
			// console.log('商品',escape(JSON.stringify(paraminfo)));
			// return false;
			this.$tool.loading('正在获取商品',this.divclass);
			this.$apipost.get.GetBaseCargoList({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				//console.log('商品信息',res,);
				if(res.count==1){
					that.addcargorow(res.data);
				}else{
					if(iscallback){
						if(res.count>1)
							//根据返回内容回填到列表
							that.addcargorow(res.data,true);
					}else{
						//弹出选择框
						that.showcargolistwin=true;
						that.cargoparam={
							searchlist:search,
							storehouse:this.stockin.storehouse,
							type:'select',
						};
						if(that.$refs.selectcargo!=undefined)
							that.$refs.selectcargo.init(that.cargoparam);	
					}			
				}
			});
		},
		//确认选择
		surecargo(){
			//debugger;
			if(this.$refs.selectcargo.selectedall){
				if(this.$refs.selectcargo.cargolist.length>0)
					this.GetCargo({search:this.$refs.selectcargo.GetSearchObj(),index:this.gridrowindex,colindex:this.gridcolindex},true);
			}
			else{
				if(this.$refs.selectcargo.checkedrow.length>0)
					this.addcargorow(this.$refs.selectcargo.checkedrow,true);
			}
		},
		//填写行
		addcargorow(rows,isclose){
			if(isclose==undefined)
				isclose=false;
			//console.log('选中行',rows);
			
			var that=this;
			var rowindex=this.gridrowindex;
			//判断新添加的商品是否已存在在已添加列表中，有则累加数量，没有则新增行
			that.stockin.cargolist.forEach(e=>{
				var index=0;
				rows.forEach(r=>{
					if(r.id==e.id&&e.id!=''){
						e.num=parseInt(e.num)+1;
						//移除此行
						rows.splice(index, 1);
					}
					index++;
				});
			});
			rows.forEach(e=>{
				if(rowindex>that.gridrowindex)
					that.stockin.cargolist.splice(rowindex, 0, JSON.parse(JSON.stringify(this.cargorow)));
				for (var key in that.stockin.cargolist[rowindex]) {
					for(var cargokey in e){
						if (cargokey == key) {
							that.stockin.cargolist[rowindex][key] =e[key];
							break;
						}
					}
					if(key=='num')
						that.stockin.cargolist[rowindex][key] ='1';
				}
				rowindex++;
			});
			if(isclose)
				this.closecargo();
			else
			{
				if(rows.length>0){
					this.$refs.tablegridstockin.setfoucsbyindex(this.gridrowindex,undefined,'num');
				}
			}
		},
		//关闭选择商品
		closecargo(){
			this.showcargolistwin=false;
			if(this.stockin.cargolist[this.gridrowindex].id!=undefined)
				this.$refs.tablegridstockin.setfoucsbyindex(this.gridrowindex,undefined,'num');
		},
		//保存入库单
		savestockin(){
			var that=this;
			if(this.stockin.crm_c_id==''){
				this.$tool.message('请填写供应商', 0);
				return false;
			}
			if(this.stockin.storehouse==''){
				this.$tool.message('请选择所在仓库', 0);
				return false;
			}
			if(this.stockin.cargolist.length>0){
				//移除id为空的，表示未选择商品
				var index=0;
				this.stockin.cargolist.forEach(e=>{
					if(e.id=='')
						that.stockin.cargolist.splice(index, 1);
					index=index+1;
				})
			}
			if(this.stockin.cargolist.length==0)
			{
				this.$tool.message('请填写商品明细', 0);
				return false;
			}
			var paraminfo=this.stockin;
			paraminfo.u_userid= localStorage.getItem('userid');
			paraminfo.u_account=localStorage.getItem('u_account');
			paraminfo.u_name=localStorage.getItem('u_name');
			paraminfo.u_company=localStorage.getItem('u_company');
			// console.log('入库单',escape(JSON.stringify(paraminfo)));
			// return false;
			this.$tool.loading('正在保存',this.divclass);
			this.$apipost.post.SaveStockIn({ paraminfo: paraminfo }).then(res => {
				if(res.state=='1')
				{
					this.$tool.message(res.message,1);
					setTimeout(function(){
						that.reback();
					},1500);
				}else
					this.$tool.message(res.message, 0);
			});
		},
		//返回
		reback() {
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
}
</script>

<style>
</style>
